import React from 'react';
import { View, ActivityIndicator, Text } from 'react-native';
import { useRouter } from 'expo-router';
import { ROUTES } from '../../src/navigation/routes';
import { useAuth } from '../../src/context/AuthContext';
import { isPublicPhase, pathForPhase } from '../../src/navigation/phaseRedirect';
import { brand } from '../../src/design-system/theme/tokens';

const DEBUG_ROUTER = (process.env.EXPO_PUBLIC_DEBUG_ROUTER || '').toLowerCase() === 'true';

export default function PublicIndex() {
  const router = useRouter();
  const { phase } = useAuth();

  React.useEffect(() => {
    if (DEBUG_ROUTER || phase === 'loading') {
      return;
    }

    const target = isPublicPhase(phase)
      ? ROUTES.PUBLIC_LOGIN
      : pathForPhase(phase);

    router.replace(target as any);
  }, [phase, router]);

  if (DEBUG_ROUTER) {
    const timestamp = new Date().toISOString();
    console.log('🟢 PUBLIC INDEX DEBUG RENDERED', timestamp);

    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#ff0000',
        }}
      >
        <Text
          style={{
            color: '#ffffff',
            fontSize: 24,
            fontWeight: '700',
          }}
        >
          EXPO ROUTER WORKING
        </Text>
        <Text
          style={{
            color: '#ffffff',
            fontSize: 16,
            marginTop: 20,
          }}
        >
          {timestamp}
        </Text>
      </View>
    );
  }

  return (
    <View style={{
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: brand.primary
    }}>
      <ActivityIndicator size="large" color="#ffffff" />
    </View>
  );
}
